import {
    StyledPurpleContainer,
    StyledTwoScreensWrapper,
} from '@/operator/components/modules/AuthPage/Styles';
import { MessageWithTip } from '@/operator/components/modules/AuthPage/setup/MessageWithTip';
import Content from '@/operator/components/modules/AuthPage/setup/signin/existingOrgContent';
import ExistingOrgDescription from '@/operator/components/modules/AuthPage/setup/signin/existingOrgDescription';
import useAuth from 'Modules/firebase/use-auth';
import { Celebration } from '@mui/icons-material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LoginPage from 'app/Pages/LoginPage';

const LoginAuthPage = (): JSX.Element => {
    const { t } = useTranslation();

    // redirects for auth on direct access
    const { isAuthenticated, loading } = useAuth();

    if (!loading && !isAuthenticated) {
        return <LoginPage />;
    }

    return (
        <StyledTwoScreensWrapper>
            <MessageWithTip
                Icon={Celebration}
                headlineVariant="h1"
                headline={t('SignIn.Content.Header')}
                description={<ExistingOrgDescription />}
            />
            <StyledPurpleContainer>
                <Content />
            </StyledPurpleContainer>
        </StyledTwoScreensWrapper>
    );
};

export default LoginAuthPage;
